import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const SaveContentConfirmationDialog = ({ showConfirmationDialog, setShowConfirmationDialog, isSubmitting }) => {
  return (
    <Dialog
      visible={showConfirmationDialog}
      header={'Confirm adding new content'}
      onHide={() => setShowConfirmationDialog(false)}
    >
      <p>
        Please make sure you've added all the new content as is required. Clicking 'Save' will save that content to the
        database and Weblate.
      </p>
      <div className="mt20 flex-center">
        <Button
          type="submit"
          icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
          className="p-button-primary"
          label="Save"
        />
        <Button
          type="button"
          className="p-button-secondary"
          label="Cancel"
          onClick={() => setShowConfirmationDialog(false)}
        />
      </div>
    </Dialog>
  );
};

export default SaveContentConfirmationDialog;
